<!-- Time Tracking -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-clock"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Time Tracking</h1>
        <p class="page-description">Monitor staff attendance and working hours</p>
      </div>
    </div>
  </div>
</div>

<!-- Filters -->
<div class="filters-panel">
  <div class="filter-group">
    <div class="search-box" style="flex: 1; max-width: 320px;">
      <div class="search-input-wrapper">
        <i class="fas fa-search search-icon"></i>
        <input type="text" class="search-input" placeholder="Search staff..." />
      </div>
    </div>

    <div ngbDropdown class="d-inline-block" container="body">
      <button type="button" class="btn btn-outline-secondary" id="dropdownBasic1" ngbDropdownToggle>
        <i class="fas fa-calendar-alt me-2"></i>Filter by Date
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem>Today</button>
        <button ngbDropdownItem>This week</button>
        <button ngbDropdownItem>This Month</button>
        <button ngbDropdownItem>Custom</button>
      </div>
    </div>
  </div>
</div>

<!-- Time Tracking Content -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-user-clock"></i>
      </div>
      <div class="title-content">
        <div class="title-text">Staff Time Records</div>
        <div class="title-subtitle">Order assignments and time logs</div>
      </div>
    </div>
  </div>

  <div class="panel-body" style="padding: 20px;">
    <!-- Sample Record Card -->
    <div style="padding: 16px 20px; border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-muted);">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div class="d-flex gap-4 flex-wrap">
          <div>
            <div style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 2px;">Order ID</div>
            <div style="font-size: 14px; font-weight: 600; color: var(--text-primary);">0123485762</div>
          </div>
          <div>
            <div style="font-size: 11px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 2px;">Waiter</div>
            <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">Flora Ikuigbe</div>
          </div>
        </div>
        <div>
          <span style="font-size: 12px; color: var(--text-tertiary);">
            <i class="fas fa-calendar-alt me-1"></i>25-04-2024 02:00PM
          </span>
        </div>
      </div>
    </div>

    <!-- Empty State (show when no records exist) -->
    <!-- <div class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-clock fa-3x"></i>
      </div>
      <div class="empty-content">
        <h5>No Time Records</h5>
        <p>There are no time tracking records to display. Records will appear here once staff activities are logged.</p>
      </div>
    </div> -->
  </div>
</div>
